/* eslint-disable @typescript-eslint/no-namespace */
import box, { boxVariants } from './box';
import list, { listVariants } from './list';
import type { Utility } from '../../../types/utility';

export namespace Combobox {
  /** Combobox Component Variant Keys */
  export type ComponentKeys = 'box' | 'list';

  /** Combobox Components */
  export type Components = {
    /** The Combobox Box subcomponent types. */
    Box: Box.VariantKeys;
    /** The Combobox List subcomponent types. */
    List: List.VariantKeys;
  };

  /** Combobox Component Variants */
  export type Variants = {
    [CompKey in ComponentKeys]: CompKey extends 'box' ? Box.Variants : CompKey extends 'list' ? List.Variants : never;
  };

  /** Combobox Component Variant Modes */
  export type VariantModes = {
    [CompKey in ComponentKeys]: Utility.VariantModes<
      CompKey extends 'box' ? Box.Variants : CompKey extends 'list' ? List.Variants : never
    >;
  };

  /** Combobox Box Component */
  export namespace Box {
    export type VariantKeys =
      | 'default'
      | 'bottomLine'
      | 'thickBottomLine'
      | 'paddedSquare'
      | 'paddedRounded'
      | 'form'
      | 'search';

    /** Combobox Box Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** Combobox List Component */
  export namespace List {
    /** Combobox List Component Variant Keys */
    export type VariantKeys = 'default' | 'splitDark' | 'large' | 'blueHighlight' | 'form' | 'simple';

    /** Combobox List Component Variants */
    export type Variants = {
      [Key in VariantKeys]: Utility.CSSProperties;
    };
  }

  /** Combobox Component Scale Keys */
  export type ScaleKeys = {
    [CompKey in ComponentKeys]: CompKey extends 'box'
      ? Array<`${CompKey}.${Box.VariantKeys}`>
      : CompKey extends 'list'
        ? Array<`${CompKey}.${List.VariantKeys}`>
        : never;
  };
}

const combobox = {
  box,
  list,
};

export const comboboxVariants = {
  box: boxVariants,
  list: listVariants,
};

export default combobox;
